import { render, staticRenderFns } from "./documents-preview.vue?vue&type=template&id=6c987990&scoped=true"
import script from "./documents-preview.vue?vue&type=script&lang=js"
export * from "./documents-preview.vue?vue&type=script&lang=js"
import style0 from "./documents-preview.vue?vue&type=style&index=0&id=6c987990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c987990",
  null
  
)

export default component.exports